import hash from 'object-hash';
import { createCollectionReducer } from 'next/lib/collections';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectScreenshots = state => state[TYPE];
export const selectScreenshot = (state, { force, ...screenshot }) =>
  selectScreenshots(state)?.[hash(screenshot)];
